import React, { PropsWithChildren } from 'react';
import PlanCalloutWrapper from './layout/PlanCalloutWrapper';

type FreeTrialCalloutProps = PropsWithChildren<{
  trialDaysRemaining: number;
}>;

function FreeTrialCallout({ trialDaysRemaining }: FreeTrialCalloutProps): JSX.Element {
  // Need to account for trialDaysRemaining being 0
  const showCallout = !!trialDaysRemaining || (Number.isFinite(trialDaysRemaining) && trialDaysRemaining >= 0);
  return (
    <>
      {showCallout && (
        <PlanCalloutWrapper intent="warning" icon="warning-sign">
          You have {trialDaysRemaining} days remaining in your trial.
        </PlanCalloutWrapper>
      )}
    </>
  );
}

export default FreeTrialCallout;
